import { makeStyles } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { SidebarItem } from '@backstage/core-components';
import { SearchModal, useSearchModal } from '@backstage/plugin-search';
import { QuickSearchModal } from '../search/QuickSearchModal';

const useStyles = makeStyles(theme => ({
  shortcut: {
    border: '1px solid currentColor',
    borderRadius: 4,
    fontFamily: 'inherit',
    fontSize: '0.7rem',
    lineHeight: 1.5,
    opacity: 0.75,
    padding: theme.spacing(0, 0.5),
    whiteSpace: 'nowrap',
  },
}));

const getShortcutLabel = () => {
  if (typeof navigator === 'undefined') {
    return 'Ctrl K';
  }

  return /Macintosh|Mac OS X|iPhone|iPad|iPod/.test(navigator.userAgent)
    ? '⌘ K'
    : 'Ctrl K';
};

export const SidebarSearchWithShortcut = () => {
  const classes = useStyles();
  const { state, toggleModal } = useSearchModal();
  const shortcutLabel = getShortcutLabel();

  return (
    <>
      <SidebarItem icon={SearchIcon} text="Search" onClick={toggleModal}>
        <kbd
          aria-hidden="true"
          className={classes.shortcut}
          title={`${shortcutLabel} keyboard shortcut`}
        >
          {shortcutLabel}
        </kbd>
      </SidebarItem>
      <SearchModal {...state} toggleModal={toggleModal}>
        {({ toggleModal: closeModal }) => (
          <QuickSearchModal toggleModal={closeModal} />
        )}
      </SearchModal>
    </>
  );
};
